import axios from "axios";

export const WarehouseApi = {
    async getListCellLocation(params) {
        const response = await axios.post(`/api/warehouse/GetListCellLocation`, params);
        return response;
    },

    async getListCellBalance(payload) {
        const response = await axios.post("/api/warehouse/GetListCellBalance", payload);
        return response;
    },

    async createCellLocation(data) {
        const response = await axios.post(`/api/warehouse/CreateCellLocation`, data);
        return response;
    },

    async updateCellLocation(data) {
        const response = await axios.post(`/api/warehouse/UpdateCellLocation`, data);
        return response;
    },

    async deleteCellLocation(id) {
        const response = await axios.post(`/api/warehouse/DeleteCellLocation`, { Id: id });
        return response;
    },

    async insertCellTransfer(payload) {
        const response = await axios.post("/api/warehouse/insertCellTransfer", { StockTransferModel: payload });
        return response;
    },
    async getPurchaseInvoices(params) {
        const payload = { ...params, DocumentTypeInt: 1, IsDepoyaAktarilanlariDahilEt: false };
        const response = await axios.post("/api/netsis/invoice/purchase/list", payload);
        return response;
    },
    async getSalesOrders(params) {
        const response = await axios.post("/api/netsis/order/sales/list", params);
        return response;
    },
    async importInvoiceToBuffer(params) {
        const response = await axios.post("/api/warehouse/importPuchaseInvoiceItemsToBuffer", params);
        return response;
    },
    async getAllCellLocations() {
        const response = await axios.post(`/api/warehouse/GetListCellLocation`, { Take: 10000 });
        return response;
    },
};
